import * as i0 from '@angular/core';
import { EventEmitter, forwardRef, Component, ViewEncapsulation, Input, Output, ViewChild, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { SvgIcons } from '@niceltd/cxone-components/shared-services';
import * as i1 from '@angular/platform-browser';
const _c0 = ["numericInput"];
const _c1 = a0 => ({
  "disabled": a0
});
class NumericSelectorComponent {
  constructor(domSanitizer, renderer) {
    this.domSanitizer = domSanitizer;
    this.renderer = renderer;
    /**
     * The steps of the value
     */
    this.step = 1;
    this.signClicked = new EventEmitter();
    /**
     * The registered callback function called when a change event occurs on the numeric selector element.
     */
    this.onChangedCallback = _ => {}; // eslint-disable-line @typescript-eslint/no-unused-vars
    /**
     * The registered callback function called when a blur event occurs on the numeric selector element.
     */
    this.onTouchedCallback = () => {};
    this.onInput = event => {
      clearTimeout(this.automaticResetDebouncer);
      const oldValue = this.inputedValue || this.value;
      this.inputedValue = event.target.value;
      if (!this.inputedValue || this.inputedValue === '-0') {
        // -0 important //
        return;
      }
      if (this.valueMatchMinRestriction(parseFloat(this.inputedValue)) === false) {
        return this.reset(this.min);
      }
      if (this.valueMatchMaxRestriction(parseFloat(this.inputedValue)) === false) {
        return this.reset(this.max);
      }
      if (oldValue !== event.target.value) {
        this.doNumberChanged(event);
      }
    };
    this.onBlur = () => {
      if (!this.inputedValue) {
        this.writeValue(this.value);
      }
    };
    this.valueMatchMinRestriction = value => {
      return typeof this.min !== 'number' || value >= this.min ? true : false;
    };
    this.valueMatchMaxRestriction = value => {
      return typeof this.max !== 'number' || value <= this.max ? true : false;
    };
    this.reset = value => {
      this.inputedValue = value;
      this.automaticResetDebouncer = setTimeout(() => {
        this.onInputedValueChanged();
      }, 600);
    };
    this.setInitialValue = maxOrMin => {
      let initialValue;
      if (this.min && this.max && (this.min > 0 || this.max < 0)) {
        initialValue = maxOrMin === 'max' ? this.max : this.min;
      } else {
        initialValue = 0;
      }
      this.writeValue(initialValue);
      return initialValue;
    };
    this.add = (value, step) => {
      return Math.round((value + step + Number.EPSILON) * 100) / 100;
    };
    this.svgIcons = new SvgIcons(this.domSanitizer);
    this.icons = {
      plus: this.svgIcons.getSvgIcons('icon-plus'),
      minus: this.svgIcons.getSvgIcons('icon-minus')
    };
    if (this.min && this.max && this.min > this.max) {
      this.max = this.min;
    }
  }
  ngOnInit() {}
  /**
   * take the value forwards step steps
   */
  incremente(event) {
    if (this.disabled) {
      return;
    }
    if (typeof this.value !== 'number') {
      this.setInitialValue('min');
    }
    const num = this.add(this.value, this.step);
    if (num > this.max) {
      return;
    }
    this.inputedValue = num;
    this.doNumberChanged(event);
  }
  /**
   * take the value backwards step steps
   */
  decremente(event) {
    if (this.disabled) {
      return;
    }
    if (typeof this.value !== 'number') {
      this.setInitialValue('max');
    }
    const num = this.add(this.value, -this.step);
    if (num < this.min) {
      return;
    }
    this.inputedValue = num;
    this.doNumberChanged(event);
  }
  /**
   * Registers a function called when the control value changes.
   */
  registerOnChange(fn) {
    this.onChangedCallback = fn;
  }
  /**
   * Registers a function called when the control is touched.
   */
  registerOnTouched(fn) {
    this.onTouchedCallback = fn;
  }
  /**
   * Write a value to the html element
   */
  writeValue(value) {
    this.value = this.parseToNumber(value);
    if (this.numericInput) {
      this.renderer.setProperty(this.numericInput.nativeElement, 'value', this.value);
    }
  }
  /**
   * every change in the value
   */
  onInputedValueChanged() {
    this.writeValue(this.inputedValue);
    this.onChangedCallback(this.value);
  }
  doNumberChanged(event) {
    this.onInputedValueChanged();
    this.signClicked.emit();
    if (event && event.stopPropagation) event.stopPropagation();
  }
  parseToNumber(value) {
    if (typeof value === 'string' && value) {
      return parseFloat(value);
    }
    return value;
  }
  /** @nocollapse */
  static {
    this.ɵfac = function NumericSelectorComponent_Factory(t) {
      return new (t || NumericSelectorComponent)(i0.ɵɵdirectiveInject(i1.DomSanitizer), i0.ɵɵdirectiveInject(i0.Renderer2));
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: NumericSelectorComponent,
      selectors: [["cxone-numeric-selector"]],
      viewQuery: function NumericSelectorComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c0, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.numericInput = _t.first);
        }
      },
      inputs: {
        step: "step",
        disabled: "disabled",
        min: "min",
        max: "max"
      },
      outputs: {
        signClicked: "signClicked"
      },
      features: [i0.ɵɵProvidersFeature([{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NumericSelectorComponent),
        multi: true
      }])],
      decls: 6,
      vars: 9,
      consts: [[1, "numeric-selector", 3, "ngClass"], ["type", "number", 1, "numeric-selector-value", 3, "step", "min", "max", "disabled", "change", "keyup", "blur"], ["numericInput", ""], [1, "numeric-selector-math"], [1, "numeric-selector-btn", "numeric-selector-math-add", 3, "innerHTML", "click"], [1, "numeric-selector-btn", "numeric-selector-math-remove", 3, "innerHTML", "click"]],
      template: function NumericSelectorComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "input", 1, 2);
          i0.ɵɵlistener("change", function NumericSelectorComponent_Template_input_change_1_listener($event) {
            return ctx.onInput($event);
          })("keyup", function NumericSelectorComponent_Template_input_keyup_1_listener($event) {
            return ctx.onInput($event);
          })("blur", function NumericSelectorComponent_Template_input_blur_1_listener() {
            return ctx.onBlur();
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(3, "div", 3)(4, "div", 4);
          i0.ɵɵlistener("click", function NumericSelectorComponent_Template_div_click_4_listener($event) {
            return ctx.incremente($event);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(5, "div", 5);
          i0.ɵɵlistener("click", function NumericSelectorComponent_Template_div_click_5_listener($event) {
            return ctx.decremente($event);
          });
          i0.ɵɵelementEnd()()();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(7, _c1, ctx.disabled));
          i0.ɵɵadvance();
          i0.ɵɵproperty("step", ctx.step)("min", ctx.min)("max", ctx.max)("disabled", ctx.disabled);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("innerHTML", ctx.icons.plus, i0.ɵɵsanitizeHtml);
          i0.ɵɵadvance();
          i0.ɵɵproperty("innerHTML", ctx.icons.minus, i0.ɵɵsanitizeHtml);
        }
      },
      dependencies: [i2.NgClass],
      styles: [".numeric-selector{display:flex}.numeric-selector.disabled input[type=number]{background-color:#f8f8f8;border-color:#dae2e8;color:#707e8d}.numeric-selector.disabled .numeric-selector-math{border-color:#dae2e8;background-color:#f8f8f8}.numeric-selector.disabled .numeric-selector-math .numeric-selector-btn{pointer-events:none}.numeric-selector.disabled .numeric-selector-math .numeric-selector-btn:hover,.numeric-selector.disabled .numeric-selector-math .numeric-selector-btn:active{background-color:#f8f8f8}.numeric-selector.disabled .numeric-selector-math svg{fill:#93a4aa}.numeric-selector.disabled .numeric-selector-math .numeric-selector-math-add{border-color:#dae2e8}.numeric-selector :focus{outline:none}.numeric-selector input[type=number]{box-sizing:border-box;width:55px;height:35px;border:1px solid #dde4e9;border-right:none;background-color:#fff;padding:8px;font-size:13px;color:#2e2e2e;-moz-appearance:textfield}.numeric-selector input[type=number]::-webkit-outer-spin-button,.numeric-selector input[type=number]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.numeric-selector .numeric-selector-math{-webkit-user-select:none;user-select:none;width:20px;height:35px;box-sizing:border-box;border:1px solid rgb(176,205,219);border-radius:0 2px 2px 0;background-color:#fff;overflow:hidden}.numeric-selector .numeric-selector-btn{width:100%;height:17px;cursor:pointer;display:flex;justify-content:center;align-items:center}.numeric-selector .numeric-selector-btn svg{width:10px;fill:#93a4aa}.numeric-selector .numeric-selector-btn:hover{background-color:#f7fafc}.numeric-selector .numeric-selector-btn:active{background-color:#f0f7fc}.numeric-selector .numeric-selector-btn.numeric-selector-math-add{border-bottom:1px solid rgb(176,205,219)}.numeric-selector .numeric-selector-btn.numeric-selector-math-add svg{height:10px}.numeric-selector .numeric-selector-btn.numeric-selector-math-remove svg{height:3px}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NumericSelectorComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-numeric-selector',
      providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => NumericSelectorComponent),
        multi: true
      }],
      encapsulation: ViewEncapsulation.None,
      template: "<div class=\"numeric-selector\" [ngClass]=\"{ 'disabled': disabled }\">\n  <input #numericInput\n         type=\"number\"\n         [step]=\"step\"\n         [min]=\"min\"\n         [max]=\"max\"\n         (change)=\"onInput($event)\"\n         (keyup)=\"onInput($event)\"\n         (blur)=\"onBlur()\"\n         [disabled]=\"disabled\"\n         class=\"numeric-selector-value\">\n\n  <div class=\"numeric-selector-math\">\n    <div class=\"numeric-selector-btn numeric-selector-math-add\" (click)=\"incremente($event)\" [innerHTML]=\"icons.plus\">\n    </div>\n    <div class=\"numeric-selector-btn numeric-selector-math-remove\" (click)=\"decremente($event)\" [innerHTML]=\"icons.minus\">\n    </div>\n  </div>\n</div>\n\n",
      styles: [".numeric-selector{display:flex}.numeric-selector.disabled input[type=number]{background-color:#f8f8f8;border-color:#dae2e8;color:#707e8d}.numeric-selector.disabled .numeric-selector-math{border-color:#dae2e8;background-color:#f8f8f8}.numeric-selector.disabled .numeric-selector-math .numeric-selector-btn{pointer-events:none}.numeric-selector.disabled .numeric-selector-math .numeric-selector-btn:hover,.numeric-selector.disabled .numeric-selector-math .numeric-selector-btn:active{background-color:#f8f8f8}.numeric-selector.disabled .numeric-selector-math svg{fill:#93a4aa}.numeric-selector.disabled .numeric-selector-math .numeric-selector-math-add{border-color:#dae2e8}.numeric-selector :focus{outline:none}.numeric-selector input[type=number]{box-sizing:border-box;width:55px;height:35px;border:1px solid #dde4e9;border-right:none;background-color:#fff;padding:8px;font-size:13px;color:#2e2e2e;-moz-appearance:textfield}.numeric-selector input[type=number]::-webkit-outer-spin-button,.numeric-selector input[type=number]::-webkit-inner-spin-button{-webkit-appearance:none;margin:0}.numeric-selector .numeric-selector-math{-webkit-user-select:none;user-select:none;width:20px;height:35px;box-sizing:border-box;border:1px solid rgb(176,205,219);border-radius:0 2px 2px 0;background-color:#fff;overflow:hidden}.numeric-selector .numeric-selector-btn{width:100%;height:17px;cursor:pointer;display:flex;justify-content:center;align-items:center}.numeric-selector .numeric-selector-btn svg{width:10px;fill:#93a4aa}.numeric-selector .numeric-selector-btn:hover{background-color:#f7fafc}.numeric-selector .numeric-selector-btn:active{background-color:#f0f7fc}.numeric-selector .numeric-selector-btn.numeric-selector-math-add{border-bottom:1px solid rgb(176,205,219)}.numeric-selector .numeric-selector-btn.numeric-selector-math-add svg{height:10px}.numeric-selector .numeric-selector-btn.numeric-selector-math-remove svg{height:3px}\n"]
    }]
  }], () => [{
    type: i1.DomSanitizer
  }, {
    type: i0.Renderer2
  }], {
    step: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    min: [{
      type: Input
    }],
    max: [{
      type: Input
    }],
    signClicked: [{
      type: Output
    }],
    numericInput: [{
      type: ViewChild,
      args: ['numericInput', {
        static: true
      }]
    }]
  });
})();
class NumericSelectorModule {
  /** @nocollapse */static {
    this.ɵfac = function NumericSelectorModule_Factory(t) {
      return new (t || NumericSelectorModule)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: NumericSelectorModule
    });
  }
  /** @nocollapse */
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(NumericSelectorModule, [{
    type: NgModule,
    args: [{
      declarations: [NumericSelectorComponent],
      imports: [CommonModule, FormsModule],
      providers: [],
      exports: [NumericSelectorComponent]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { NumericSelectorComponent, NumericSelectorModule };
